// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bi-0";
export var headerCellHover = "_bi-1";
export var readCellContainer = "_bi-2";
export var readCellSlot = "_bi-3";
export var rowHoverCheckbox = "_bi-4";
export var rowUnreadIndicator = "_bi-5";
export var searchHighlight = "_bi-8";
export var summaryCellHoverWrapper = "_bi-9";
export var supportTicketRow = "_bi-6";
export var unreadIndicator = "_bi-7";